import React from 'react'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { Attachments } from './attachments'
import { Link } from 'react-router-dom'

class CbsReportsContent extends React.Component {
  onDownloadClick = () => {
    this.props.downloadCbsReport(this.props.individualId)
  }

  render () {
    if (this.props.loading) { return <LoadingIndicator /> }

    const { reports, localize, fetching, individualId } = this.props
    const canDownload = (fetching ? false : reports.hasPersonalId)

    return (
      <React.Fragment>
        <p>
          <Button
            onClick={this.onDownloadClick}
            disabled={!canDownload}>
            {fetching && <LoadingIndicator inline />}{localize('Individuals.DownloadCbsReport')}
          </Button>
        </p>
        {!fetching && !reports.hasPersonalId && <div><Icon name='error-circle' /> <Resx name='Individuals.PersonalIdRequired' /></div>}
        <Attachments attachments={reports.attachments} />
        <Link to={`/individuals/${individualId}/cbs-reports`}>{localize('Common.ShowAll')}</Link>
      </React.Fragment>
    )
  }
}

export {
  CbsReportsContent
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/cbsReports/content.js